import { LLM_TYPES } from '@proximl-internal/mcp-core/enum';

const LLM_TYPE_LABELS = {
  [LLM_TYPES.TEXT]: 'Text Generation',
  [LLM_TYPES.EMBEDDING]: 'Embedding',
  [LLM_TYPES.MODERATION]: 'Content Moderation',
  [LLM_TYPES.TRANSCRIPTION]: 'Speech-to-Text',
  [LLM_TYPES.IMAGE]: 'Image Generation',
  [LLM_TYPES.VIDEO]: 'Video Generation',
  [LLM_TYPES.AUDIO]: 'Audio/Speech Generation',
  [LLM_TYPES.ACTION]: 'Action / Policy',
};

export default function getLlmTypeLabel(llm_type) {
  if (!llm_type) return '';
  return LLM_TYPE_LABELS[llm_type] || llm_type;
}
